import { Descendant } from "slate";

import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";
import {
  TEAM_MENTION_PREFIX,
  USER_MENTION_PREFIX,
} from "@mapmycustomers/shared/util/consts/mentions";
import userDisplayName from "@mapmycustomers/shared/util/formatters/userDisplayName";

import ElementType from "../../../../../type/slate/ElementType";
import IsMentionDisabled from "../type/IsMentionDisabled";

import { MENTIONS_REGEXP } from "./const";

const parseTextWithMentions = (
  value: string,
  users: User[],
  teams: Team[],
  isMentionDisabled?: IsMentionDisabled
): Descendant[] =>
  value.split("\n").map((text) => {
    const parts = Array.from(text.matchAll(MENTIONS_REGEXP)) as {
      groups: { team?: string; username?: string };
      index: number;
    }[];
    let currentIndex = 0;
    const children: Descendant[] = [];
    parts.forEach(({ groups: { team, username }, index }) => {
      const length = username
        ? USER_MENTION_PREFIX.length + username.length
        : team
          ? TEAM_MENTION_PREFIX.length + team.length
          : 0;
      if (index > currentIndex) {
        children.push({ text: text.substring(currentIndex, index) });
      }
      if (username) {
        const foundUser = users.find((user) => username === user.username);
        if (foundUser) {
          children.push({
            children: [{ text: "" }],
            disabled: isMentionDisabled ? isMentionDisabled(foundUser) : false,
            email: foundUser.username,
            name: userDisplayName(foundUser),
            type: ElementType.MENTION,
          });
        } else {
          children.push({ text: `${USER_MENTION_PREFIX}${username}` });
        }
      } else if (team) {
        const teamId = parseInt(team, 10);
        const foundTeam = teams.find(({ id }) => id === teamId);

        if (foundTeam) {
          children.push({
            children: [{ text: "" }],
            disabled: foundTeam.deletedAt ? true : false,
            name: foundTeam.name,
            teamId: foundTeam.id,
            type: ElementType.MENTION,
          });
        } else {
          children.push({ text: team });
        }
      }
      currentIndex = index + length;
    });

    if (text.length === 0) {
      children.push({ text: "" });
    } else if (currentIndex < text.length) {
      children.push({ text: text.substring(currentIndex, text.length) });
    }

    return {
      children,
      type: ElementType.PARAGRAPH,
    };
  });

export default parseTextWithMentions;
